import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListenbrainz = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	viewBox: "0 0 512 512",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M246.9 0 27.4 128v256l219.5 128z",
		style: { fill: "#353070" }
	}), /* @__PURE__ */ _jsx("path", {
		d: "m265.1 0 219.5 128v256L265.1 512z",
		style: { fill: "#eb743b" }
	})]
});
export default SvgListenbrainz;
